/**
 * Proforma HTML : même présentation que les factures, sans recalcul des montants.
 * Les téléchargements desktop et mobile utilisent ensuite le PDF React-PDF.
 */
import { generateInvoiceHTML } from "../gestion-vente/components/InvoiceHTMLTemplate";

export const generateProformaHTML = (data: any): string => generateInvoiceHTML({
  ...data,
  order: { ...data.order, isProforma: true },
  qrCodeDataUrl: data.qrCodeDataUrl || data.qrCode || data.order?.qrCode || "",
});
